import React, { useState } from 'react';
import { AuthContext } from '@ryanar/react-auth-provider';
import { useHistory } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { WarningModal } from 'components/modals';
import { dashboardOptions, logoutOptions, MobileSideMenu } from 'ui/structure/SideMenu';
import noop from 'utils/noop';
import api from 'api/api';
import routePaths from 'routes/routePaths';

import styles from './HeaderMenu.module.css';

import logo from 'assets/icons/fab_logo_small.png';
import close from 'assets/img/close.png';
import burger from 'assets/icons/sidemenus-PNG/menu.png';

const HeaderMenu = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [showLogOut, setShowLogOut] = useState(false);

  const history = useHistory();
  const { setAuthenticated } = React.useContext(AuthContext);

  const onOpenLogOut = () => setShowLogOut(true);
  const onCloseLogOut = () => setShowLogOut(false);

  const handleOnClick = (open: boolean) => () => setMenuOpen(open);

  const onLogOut = () => {
    api.post('/customer/logout', {}, true, false).finally(() => {
      onCloseLogOut();
      setAuthenticated(false);
    });
  };

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const onLogoClick = () => {
    if (downMdScreen) {
      history.push(routePaths.dashboard);
    }
  };

  return (
    <div className={styles.header}>
      <div
        className={styles.title}
        role="button"
        tabIndex={0}
        onClick={onLogoClick}
        onKeyPress={noop}
      >
        <img src={logo} alt="fab logo" className={styles.logo} />
        First Atlantic Bank PLC
      </div>
      <div role="button" tabIndex={0} onClick={handleOnClick(!isMenuOpen)} onKeyPress={noop} className={styles.burger}>
        {isMenuOpen ? (
          <>
            Close
            <img src={close} alt="burger menu" className={styles.icon} />
          </>
        ) : (
          <>
            Menu
            <img src={burger} alt="burger menu" className={styles.icon} />
          </>
        )}
      </div>
      <MobileSideMenu
        items={[...dashboardOptions(), logoutOptions]}
        isOpen={isMenuOpen}
        setOpen={setMenuOpen}
        menuClassName={styles.menu}
        onClick={onOpenLogOut}
      />
      <WarningModal
        open={showLogOut}
        onClose={onCloseLogOut}
        onSubmit={onLogOut}
        submitName="Log Out"
        noIcon
        showClose
      >
        Are you sure you want to log out?
      </WarningModal>
    </div>
  );
};

export default HeaderMenu;
